import { ICustomTheme } from '@/interfaces/theme';
import { API_V4_BASE_URL } from '@/settings';

import { get } from './api';

export const getSubdomainTheme = () => {
  return get({ baseURL: API_V4_BASE_URL, url: '/learner/school/config' }).then(
    response => response.data as ICustomTheme
  );
};
